import {Checkbox, Form, Input} from 'antd';
import {FormInstance} from 'antd/es/form';
import {FormListFieldData} from 'antd/es/form/FormList';
import React from 'react';

import {IRiskInfoDocDto} from '../../api/types';
import styles from './request-details-form.module.less';

interface IDocumentsBlockProps {
    riskField: FormListFieldData;
    formInstance: FormInstance;
    isEditMode: boolean;
}

export const DocumentsBlock = ({riskField, formInstance, isEditMode}: IDocumentsBlockProps) => {
    const documents: IRiskInfoDocDto[] = formInstance.getFieldValue(['risks', riskField.name, 'documents']) || [];

    if (documents.length === 0) {
        return null;
    }

    return (
        <div className={styles['request-details-form__docs-section']}>
            <div className={styles['request-details-form__docs-title']}>Документы</div>

            <Form.List name={[riskField.name, 'documents']}>
                {(docFields) => (
                    <>
                        {docFields.map((docField) => (
                            <div
                                key={docField.key}
                                className={`${styles['request-details-form__doc-row']} d-flex gap-2 align-items-end`}
                            >
                                <Form.Item
                                    label="Идентификатор документа в ИС НП"
                                    name={[docField.name, 'aisDocId']}
                                    className={styles['request-details-form__doc-ais-id']}
                                >
                                    <Input disabled />
                                </Form.Item>
                                <Form.Item
                                    label="Активно"
                                    name={[docField.name, 'activeFlag']}
                                    valuePropName="checked"
                                >
                                    <Checkbox disabled={!isEditMode} />
                                </Form.Item>
                            </div>
                        ))}
                    </>
                )}
            </Form.List>
        </div>
    );
};
